import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Link, ListItem, UnorderedList } from '@chakra-ui/react';

import { TaxForecastProfileTaxCalculationMode } from '__generated__/GQL';
import * as Form from 'components/_core/form';
import SunshineCard from 'components/_core/SunshineCard';

import { PersonalizedTaxTypeSchema } from '../../taxType.schema';
import { locales } from './locales';

interface PersonalizedCardProps {
  isSelected: boolean;
}

const PersonalizedCard: FC<PersonalizedCardProps> = ({ isSelected }) => {
  const {
    formState: { errors },
    register,
  } = useFormContext<PersonalizedTaxTypeSchema>();

  return (
    <SunshineCard.Group isActive={isSelected}>
      <SunshineCard
        title={locales.title}
        value={TaxForecastProfileTaxCalculationMode.Custom}
        variant="radio"
      />

      {isSelected ? (
        <SunshineCard>
          <SunshineCard.Content alignItems="stretch" gap="space-16">
            <SunshineCard.Title>{locales.subtitle}</SunshineCard.Title>

            <Box>
              <SunshineCard.Text>{locales.description}</SunshineCard.Text>

              <UnorderedList>
                <ListItem>
                  <SunshineCard.Text>{locales.payslip}</SunshineCard.Text>
                </ListItem>

                <ListItem>
                  <SunshineCard.Text>
                    {locales.taxDeclaration}
                  </SunshineCard.Text>
                </ListItem>

                <ListItem>
                  <SunshineCard.Text>
                    {locales.personalSpace}
                    <Link
                      fontWeight="normal"
                      href="https://www.impots.gouv.fr/accueil"
                      isExternal
                      size="sm"
                    >
                      impots.gouv.fr
                    </Link>
                  </SunshineCard.Text>
                </ListItem>
              </UnorderedList>
            </Box>

            <Form.Field
              error={errors.customRate?.message}
              label={locales.customRate}
            >
              <Form.Input
                inputMode="decimal"
                onFocus={(e) => e.target.select()}
                placeholder="0"
                rightIcon="percentage"
                type="number"
                {...register('customRate', {
                  valueAsNumber: true,
                })}
              />
            </Form.Field>
          </SunshineCard.Content>
        </SunshineCard>
      ) : null}
    </SunshineCard.Group>
  );
};

export default PersonalizedCard;
